import { useTranslation } from "@opendash/i18n";
import { Form, Switch } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { PathContext } from "../../../context/PathContext";
import { FormItemPath } from "../../../types/Config";

type Props = {};

export const RequiredCheckbox = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return (
    <Form.Item<FormItemPath>
      label={t("maintenance:ticket.create.config.general.required.label")}
      name={[...path, "required"]}
      valuePropName="checked"
      layout="vertical"
      help={t("maintenance:ticket.create.config.general.required.help")}
    >
      <Switch
        unCheckedChildren={t(
          "maintenance:ticket.create.config.general.required.unCheckedChildren"
        )}
        checkedChildren={t(
          "maintenance:ticket.create.config.general.required.checkedChildren"
        )}
      />
    </Form.Item>
  );
});
